const formatDateTime = (dateTimeString) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const date = new Date(dateTimeString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.getMonth();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;

  const formattedDateTime = `${day}-${months[month]}-${year} ${displayHours}:${minutes}:${seconds} ${ampm}`;

  return formattedDateTime;
};
const formatDateTimeAmPm = (dateTimeString) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const date = new Date(dateTimeString);
  const day = date.getDate();
  const month = date.getMonth(); // 0-indexed
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const amPM = hours >= 12 ? "PM" : "AM"; // Determine if it's AM or PM
  const displayHours = hours % 12 || 12; // Convert to 12-hour format

  const dayString = String(day).padStart(2, "0");
  const monthString = months[month];
  const timeString = `${displayHours}:${String(minutes).padStart(
    2,
    "0",
  )} ${amPM}`; // Include AM/PM
  const formattedDateTime = `${dayString}-${monthString}-${year} ${timeString}`;

  return formattedDateTime;
};

// Test the function

const formatDate = (dateString) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth(); // ''-indexed
  const year = date.getFullYear();
  const dayString = String(day).padStart(2, "");
  const monthString = months[month];
  const formattedDate = `${dayString}-${monthString}-${year}`;

  return formattedDate;
};

function formatDate2(dateString) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  const dayString = String(day).padStart(2, "0");
  const monthString = months[month];
  const formattedDate = `${dayString}-${monthString}-${year}`;
  return formattedDate;
}
const BachformatDate = () => {
  const date = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  const monthStr = months[month];
  return `${day}${monthStr}${year}`;
};

function currentDateTime() {
  const currentDateTime = new Date();
  const year1 = currentDateTime.getFullYear();
  const month = String(currentDateTime.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(currentDateTime.getDate()).padStart(2, "0");
  const hours = String(currentDateTime.getHours()).padStart(2, "0");
  const minutes = String(currentDateTime.getMinutes()).padStart(2, "0");
  const seconds = String(currentDateTime.getSeconds()).padStart(2, "0");
  return `${year1}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function currentDate() {
  const currentDateTime = new Date();
  const year = currentDateTime.getFullYear();
  const month = String(currentDateTime.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(currentDateTime.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const getDateForTomorrow = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
};

const convertToDateTimeLocalString = (datestr) => {
  const date = new Date(datestr);
  const year = date?.getFullYear();
  const month = (date?.getMonth() + 1).toString().padStart(2, "0");
  const day = date?.getDate().toString().padStart(2, "0");
  const hours = date?.getHours().toString().padStart(2, "0");
  const minutes = date?.getMinutes().toString().padStart(2, "0");
  const seconds = date?.getSeconds().toString().padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

function formatDateInput(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const formatCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return {
    formattedDateTime: `${year}-${month}-${day}T${hours}:${minutes}`,
    formattedTime: `${hours}:${minutes}`,
  };
};

// --------------generate lab no i.e R1, E1, LR1 etc------------------


// const generateLabNo = (isolate, moduleStatus) => {
//   if (!isolate) return "";

//   const REPEAT_TYPES = [
//     "sequencing_repeat",
//     "rtpcr_repeat",
//     "purification_repeat",
//     "cycle_seq_repeat",
//     "dtr_repeat",
//   ];

//   // seq module mein in types ka suffix hide karna hai (R / RNA wale)
//   const SEQ_HIDE_SUFFIX_TYPES = [
//     "itd_rna",
//     "vdpv_rna",
//     "itd_cell_culture",
//     "vdpv_cell_culture",
//   ];

//   const getRepeatTypeLabel = (repeatType) => {
//     if (!REPEAT_TYPES.includes(repeatType)) return "";
//     switch (repeatType) {
//       case "sequencing_repeat":
//         return "Ext";
//       case "rtpcr_repeat":
//         return "RT";
//       case "purification_repeat":
//         return "PP";
//       case "cycle_seq_repeat":
//         return "CS";
//       case "dtr_repeat":
//         return "DTR";
//       default:
//         return "";
//     }
//   };

//   const isSeq = moduleStatus === "seq";
//   const hideSuffixForSeq =
//     isSeq && SEQ_HIDE_SUFFIX_TYPES.includes(isolate.repeat_type);

//   // ES DataSheet cases: always include sample_flask in suffix for both arms
//   if (
//     isolate.isolatable_type === "App\\Models\\EsDataSheet" &&
//     (isolate.arm_name === "L-arm" || isolate.arm_name === "RD-arm") &&
//     (isolate.repeat_type === "itd_rna" || isolate.repeat_type === "vdpv_rna")
//   ) {
//     const suffix = isolate.arm_name === "L-arm" ? "E" : "RD";
//     if (hideSuffixForSeq) {
//       return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}`;
//     }
//     return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}-RNA-R${isolate.repeat_no}`;
//   }

//   if (
//     isolate.isolatable_type === "App\\Models\\EsDataSheet" &&
//     (isolate.arm_name === "L-arm" || isolate.arm_name === "RD-arm") &&
//     (isolate.repeat_type === "itd_cell_culture" ||
//       isolate.repeat_type === "vdpv_cell_culture" ||
//       isolate.repeat_type === "sequencing_repeat" ||
//       isolate.repeat_type === "rtpcr_repeat" ||
//       isolate.repeat_type === "purification_repeat" ||
//       isolate.repeat_type === "cycle_seq_repeat" ||
//       isolate.repeat_type === "dtr_repeat")
//   ) {
//     const suffix = isolate.arm_name === "L-arm" ? "E" : "RD";
//     const repeatPrefix = REPEAT_TYPES.includes(isolate.repeat_type)
//       ? "SR"
//       : "R";
//     if (hideSuffixForSeq) {
//       return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}`;
//     }
//     const repeatTypeLabel = getRepeatTypeLabel(isolate.repeat_type);
//     return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}-${repeatPrefix}${isolate.repeat_no}${repeatTypeLabel ? `-(${repeatTypeLabel})` : ""}`;
//   }

//   if (
//     isolate.isolatable_type === "App\\Models\\EsDataSheet" &&
//     (isolate.arm_name === "L-arm" || isolate.arm_name === "RD-arm") &&
//     isolate.repeat_type === null
//   ) {
//     const suffix = isolate.arm_name === "L-arm" ? "E" : "RD";
//     return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}`;
//   }

//   // VIL DataSheet cases
//   if (
//     isolate.isolatable_type === "App\\Models\\VilDataSheet" &&
//     (isolate.repeat_type === "itd_rna" || isolate.repeat_type === "vdpv_rna")
//   ) {
//     if (hideSuffixForSeq) {
//       return `${isolate.isolatable?.lab_no}`;
//     }
//     return `${isolate.isolatable?.lab_no}-RNA-R${isolate.repeat_no}`;
//   }

//   if (
//     isolate.isolatable_type === "App\\Models\\VilDataSheet" &&
//     (isolate.repeat_type === "itd_cell_culture" ||
//       isolate.repeat_type === "vdpv_cell_culture" ||
//       isolate.repeat_type === "sequencing_repeat" ||
//       isolate.repeat_type === "rtpcr_repeat" ||
//       isolate.repeat_type === "purification_repeat" ||
//       isolate.repeat_type === "cycle_seq_repeat" ||
//       isolate.repeat_type === "dtr_repeat")
//   ) {
//     const repeatPrefix = REPEAT_TYPES.includes(isolate.repeat_type)
//       ? "SR"
//       : "R";
//     if (hideSuffixForSeq) {
//       return `${isolate.isolatable?.lab_no}`;
//     }
//     const repeatTypeLabel = getRepeatTypeLabel(isolate.repeat_type);
//     return `${isolate.isolatable?.lab_no}-${repeatPrefix}${isolate.repeat_no}${repeatTypeLabel ? `-(${repeatTypeLabel})` : ""}`;
//   }

//   return isolate.isolatable?.lab_no || "";
// };

const generateLabNo = (isolate, moduleStatus) => {
  if (!isolate) return "";

  const REPEAT_TYPES = [
    "sequencing_repeat",
    "rtpcr_repeat",
    "purification_repeat",
    "cycle_seq_repeat",
    "dtr_repeat",
  ];

  // seq module mein in types ka suffix hide karna hai (R / RNA wale)
  const SEQ_HIDE_SUFFIX_TYPES = [
    "itd_rna",
    "vdpv_rna",
    "itd_cell_culture",
    "vdpv_cell_culture",
  ];

  const getRepeatTypeLabel = (repeatType) => {
    if (!REPEAT_TYPES.includes(repeatType)) return "";
    switch (repeatType) {
      case "sequencing_repeat":
        return "Ext";
      case "rtpcr_repeat":
        return "RT";
      case "purification_repeat":
        return "PP";
      case "cycle_seq_repeat":
        return "CS";
      case "dtr_repeat":
        return "DTR";
      default:
        return "";
    }
  };

  const isSeq = moduleStatus === "seq";
  const hideSuffixForSeq =
    isSeq && SEQ_HIDE_SUFFIX_TYPES.includes(isolate.repeat_type);

  // NON-seq module: SR wale (REPEAT_TYPES) ka poora SR-suffix + label hide kar do.
  // Sirf base lab no (with sample_flask for ES) return karo.
  const hideSrForNonSeq = !isSeq && REPEAT_TYPES.includes(isolate.repeat_type);

  // ES DataSheet cases: always include sample_flask in suffix for both arms
  if (
    isolate.isolatable_type === "App\\Models\\EsDataSheet" &&
    (isolate.arm_name === "L-arm" || isolate.arm_name === "RD-arm") &&
    (isolate.repeat_type === "itd_rna" || isolate.repeat_type === "vdpv_rna")
  ) {
    const suffix = isolate.arm_name === "L-arm" ? "E" : "RD";
    if (hideSuffixForSeq) {
      return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}`;
    }
    return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}-RNA-R${isolate.repeat_no}`;
  }

  if (
    isolate.isolatable_type === "App\\Models\\EsDataSheet" &&
    (isolate.arm_name === "L-arm" || isolate.arm_name === "RD-arm") &&
    (isolate.repeat_type === "itd_cell_culture" ||
      isolate.repeat_type === "vdpv_cell_culture" ||
      isolate.repeat_type === "sequencing_repeat" ||
      isolate.repeat_type === "rtpcr_repeat" ||
      isolate.repeat_type === "purification_repeat" ||
      isolate.repeat_type === "cycle_seq_repeat" ||
      isolate.repeat_type === "dtr_repeat")
  ) {
    const suffix = isolate.arm_name === "L-arm" ? "E" : "RD";
    const repeatPrefix = REPEAT_TYPES.includes(isolate.repeat_type)
      ? "SR"
      : "R";
    if (hideSuffixForSeq) {
      return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}`;
    }
    // non-seq: SR wale ka poora suffix hata do
    if (hideSrForNonSeq) {
      return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}`;
    }
    const repeatTypeLabel = getRepeatTypeLabel(isolate.repeat_type);
    return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}-${repeatPrefix}${isolate.repeat_no}${repeatTypeLabel ? `-(${repeatTypeLabel})` : ""}`;
  }

  if (
    isolate.isolatable_type === "App\\Models\\EsDataSheet" &&
    (isolate.arm_name === "L-arm" || isolate.arm_name === "RD-arm") &&
    isolate.repeat_type === null
  ) {
    const suffix = isolate.arm_name === "L-arm" ? "E" : "RD";
    return `${isolate.isolatable?.lab_no}-${suffix}${isolate.sample_flask}`;
  }

  // VIL DataSheet cases
  if (
    isolate.isolatable_type === "App\\Models\\VilDataSheet" &&
    (isolate.repeat_type === "itd_rna" || isolate.repeat_type === "vdpv_rna")
  ) {
    if (hideSuffixForSeq) {
      return `${isolate.isolatable?.lab_no}`;
    }
    return `${isolate.isolatable?.lab_no}-RNA-R${isolate.repeat_no}`;
  }

  if (
    isolate.isolatable_type === "App\\Models\\VilDataSheet" &&
    (isolate.repeat_type === "itd_cell_culture" ||
      isolate.repeat_type === "vdpv_cell_culture" ||
      isolate.repeat_type === "sequencing_repeat" ||
      isolate.repeat_type === "rtpcr_repeat" ||
      isolate.repeat_type === "purification_repeat" ||
      isolate.repeat_type === "cycle_seq_repeat" ||
      isolate.repeat_type === "dtr_repeat")
  ) {
    const repeatPrefix = REPEAT_TYPES.includes(isolate.repeat_type)
      ? "SR"
      : "R";
    if (hideSuffixForSeq) {
      return `${isolate.isolatable?.lab_no}`;
    }
    // non-seq: SR wale ka poora suffix hata do
    if (hideSrForNonSeq) {
      return `${isolate.isolatable?.lab_no}`;
    }
    const repeatTypeLabel = getRepeatTypeLabel(isolate.repeat_type);
    return `${isolate.isolatable?.lab_no}-${repeatPrefix}${isolate.repeat_no}${repeatTypeLabel ? `-(${repeatTypeLabel})` : ""}`;
  }

  return isolate.isolatable?.lab_no || "";
};

// Lab number for an isolate_copy row. Copy-level repeats (e.g. purification_repeat)
// store their marker on the copy itself, so overlay the copy's repeat_type/repeat_no
// onto the isolate before formatting. Falls back to the isolate's own repeat info
// (no-op) for normal copies.
const generateCopyLabNo = (copy, moduleStatus) =>
  generateLabNo(
    {
      ...copy?.isolate,
      repeat_type: copy?.repeat_type ?? copy?.isolate?.repeat_type,
      repeat_no: copy?.repeat_no ?? copy?.isolate?.repeat_no,
    },
    moduleStatus,
  );

// ---- Hide a repeat from the screens of stages BEFORE the one it restarted at ----
// A copy-/isolate-level repeat reuses (inherits) the earlier stages from its source, so its
// duplicated row also turns up in those earlier-stage screens (it kept their batch ids). It
// should only be DISPLAYED from the stage where the repeat actually restarted. `repeatStageOrder`
// ranks each repeat_type by the stage it re-enters; `stageOrder` ranks the screen. A repeat is
// hidden when it starts strictly LATER than the screen's stage. Originals (no repeat_type) and
// same/earlier repeats are always kept. The DB data is untouched — this is display-only.
// Stages are ranked on ONE unified timeline: the ITD/VDPV (cell-culture) side comes first, then
// the sequencing pipeline. A VDPV repeat keeps the original's itdbatch_id (and a sequencing/rtpcr
// repeat keeps it too), so those rows resurface on the ITD Initialized screen even though they
// restarted later — hence `itd`/`vdpv` are included here so they get hidden from ITD Initialized.
const repeatStageOrder = {
  // ITD / VDPV side
  itd_cell_culture: 0,
  itd_rna: 0,
  vdpv_cell_culture: 1, // restarts at VDPV (after ITD)
  vdpv_rna: 1,
  // Sequencing pipeline
  sequencing_repeat: 2, // re-extraction
  rtpcr_repeat: 3,
  purification_repeat: 4,
  cycle_seq_repeat: 5,
  dtr_repeat: 6,
};
const stageOrder = {
  itd: 0,
  vdpv: 1,
  extraction: 2,
  rtpcr: 3,
  purification: 4,
  cycle_seq: 5,
  dtr: 6,
};

// `record` may be an isolate row or an isolate_copy row — check both spots for repeat_type.
const isRepeatBeforeStage = (record, stage) => {
  const repeatType =
    record?.repeat_type ?? record?.isolate?.repeat_type ?? null;
  if (!repeatType) return false;
  const r = repeatStageOrder[repeatType];
  return r !== undefined && r > stageOrder[stage];
};

// Drop repeat rows that haven't reached `stage` yet (keeps originals + same/earlier repeats).
const filterRepeatsForStage = (rows, stage) =>
  Array.isArray(rows)
    ? rows.filter((row) => !isRepeatBeforeStage(row, stage))
    : rows;

// --------------lab ID color function------------------
const getLabIdColor = (caseRecord,  moduleStatus) => {
  // A copy (type === "copy") is GREEN — even if it is also a repeat ("green if it is a copy
  // of an original, regardless of repeat").
  if (
    caseRecord?.type === "copy" ||
    caseRecord?.isolate_copies?.[0]?.type === "copy"
  ) {
    return "green" || "FF00FF00";
  }

  // Has vdpv_seq_refer_date - orange
  if (
    (caseRecord?.vdpv_seq_refer_date && caseRecord?.manual_itd_refer_date) ||
    (caseRecord?.isolate?.vdpv_seq_refer_date &&
      caseRecord?.isolate?.manual_itd_refer_date)
  ) {
    return "purple"; // Purple color
    // return "orange" || "FFFFA500";
  }

  // Specific repeat types - blue
  const seqBlueRepeatTypes = [
    "sequencing_repeat",
    "rtpcr_repeat",
    "purification_repeat",
    "cycle_seq_repeat",
    "dtr_repeat",
  ];
   const itdBlueRepeatTypes = [
    "itd_rna",
    "itd_cell_culture",
    "vdpv_rna",
    "vdpv_cell_culture",
  ];

  if (
    (caseRecord?.repeat_type || caseRecord?.isolate?.repeat_type) &&
    seqBlueRepeatTypes.includes(
      caseRecord?.repeat_type || caseRecord?.isolate?.repeat_type,
    ) &&  moduleStatus === "seq"
  ) {
    return "blue" || "FF0000FF";
  }
  // ------ blue for ITD/VDPV repeat if only repeat in ITD internal
  if (
    (caseRecord?.repeat_type || caseRecord?.isolate?.repeat_type) &&
    itdBlueRepeatTypes.includes(
      caseRecord?.repeat_type || caseRecord?.isolate?.repeat_type,
    ) &&  moduleStatus === "itd"
  ) {
    return "blue" || "FF0000FF";
  }

  // Default - no color (empty string)
  return "";
};

export {
  formatDateTime,
  formatDate,
  currentDateTime,
  convertToDateTimeLocalString,
  currentDate,
  formatDateInput,
  formatDateTimeAmPm,
  BachformatDate,
  formatDate2,
  formatCurrentDateTime,
  generateLabNo,
  generateCopyLabNo,
  getLabIdColor,
  isRepeatBeforeStage,
  filterRepeatsForStage,
};
